export enum OlaNiveau {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  INFO = 'INFO'
}
